import { buildModelManager } from "../builder.js";
const DefaultAgentMessageSelection = {
  __typename: true,
  id: true,
  adminReviewed: true,
  agentConfigurationId: true,
  agentType: true,
  citationAccuracy: true,
  content: true,
  contextLength: true,
  conversationId: true,
  createdAt: true,
  debugInfo: true,
  errorDetails: true,
  escalatedToInstructor: true,
  flaggedForTraining: true,
  institution: true,
  instructorNotified: true,
  messageId: true,
  messageIndex: true,
  messageType: true,
  modelUsed: true,
  processingTimeMs: true,
  qualityRating: true,
  responseRelevance: true,
  reviewedAt: true,
  reviewedById: true,
  temperature: true,
  timestamp: true,
  tokenUsage: true,
  trainingCategory: true,
  updatedAt: true,
  userFlagReason: true,
  userFlagged: true,
  userReaction: true
};
const modelApiIdentifier = "agentMessage";
const pluralModelApiIdentifier = "agentMessages";
;
;
;
;
;
;
;
;
;
const operations = [
  {
    type: "findOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAgentMessageSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: modelApiIdentifier,
    modelApiIdentifier,
    findByVariableName: "id",
    defaultSelection: DefaultAgentMessageSelection,
    namespace: null
  },
  {
    type: "findMany",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentMessageSelection,
    namespace: null
  },
  {
    type: "findFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentMessageSelection,
    namespace: null
  },
  {
    type: "maybeFindFirst",
    operationName: pluralModelApiIdentifier,
    modelApiIdentifier,
    defaultSelection: DefaultAgentMessageSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAgentMessageSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindById",
    findByField: "id",
    findByVariableName: "id",
    modelApiIdentifier,
    defaultSelection: DefaultAgentMessageSelection,
    namespace: null
  },
  {
    type: "findOne",
    operationName: pluralModelApiIdentifier,
    functionName: "findByMessageId",
    findByField: "messageId",
    findByVariableName: "messageId",
    modelApiIdentifier,
    defaultSelection: DefaultAgentMessageSelection,
    namespace: null
  },
  {
    type: "maybeFindOne",
    operationName: pluralModelApiIdentifier,
    functionName: "maybeFindByMessageId",
    findByField: "messageId",
    findByVariableName: "messageId",
    modelApiIdentifier,
    defaultSelection: DefaultAgentMessageSelection,
    namespace: null
  },
  {
    type: "action",
    operationName: "createAgentMessage",
    operationReturnType: "CreateAgentMessage",
    functionName: "create",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      agentMessage: { required: false, type: "CreateAgentMessageInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentMessageSelection
  },
  {
    type: "action",
    operationName: "bulkCreateAgentMessages",
    functionName: "bulkCreate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "create",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkCreateAgentMessagesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAgentMessageSelection
  },
  {
    type: "action",
    operationName: "updateAgentMessage",
    operationReturnType: "UpdateAgentMessage",
    functionName: "update",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      id: { required: true, type: "GadgetID" },
      agentMessage: { required: false, type: "UpdateAgentMessageInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentMessageSelection
  },
  {
    type: "action",
    operationName: "bulkUpdateAgentMessages",
    functionName: "bulkUpdate",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "update",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpdateAgentMessagesInput!]" }
    },
    paramOnlyVariables: [],
    defaultSelection: DefaultAgentMessageSelection
  },
  {
    type: "action",
    operationName: "deleteAgentMessage",
    operationReturnType: "DeleteAgentMessage",
    functionName: "delete",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: true,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: true,
    variables: { id: { required: true, type: "GadgetID" } },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: [],
    hasReturnType: false,
    acceptsModelInput: false,
    hasCreateOrUpdateEffect: false,
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "bulkDeleteAgentMessages",
    functionName: "bulkDelete",
    isBulk: true,
    isDeleter: true,
    hasReturnType: false,
    acceptsModelInput: false,
    operatesWithRecordIdentity: true,
    singleActionFunctionName: "delete",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: { ids: { required: true, type: "[GadgetID!]" } },
    paramOnlyVariables: [],
    defaultSelection: null
  },
  {
    type: "action",
    operationName: "upsertAgentMessage",
    operationReturnType: "UpsertAgentMessage",
    functionName: "upsert",
    namespace: null,
    modelApiIdentifier,
    operatesWithRecordIdentity: false,
    modelSelectionField: modelApiIdentifier,
    isBulk: false,
    isDeleter: false,
    variables: {
      on: { required: false, type: "[String!]" },
      agentMessage: { required: false, type: "UpsertAgentMessageInput" }
    },
    hasAmbiguousIdentifier: false,
    paramOnlyVariables: ["on"],
    hasReturnType: {
      "... on CreateAgentMessageResult": { hasReturnType: false },
      "... on UpdateAgentMessageResult": { hasReturnType: false }
    },
    acceptsModelInput: true,
    hasCreateOrUpdateEffect: true,
    defaultSelection: DefaultAgentMessageSelection
  },
  {
    type: "action",
    operationName: "bulkUpsertAgentMessages",
    functionName: "bulkUpsert",
    isBulk: true,
    isDeleter: false,
    hasReturnType: false,
    acceptsModelInput: true,
    operatesWithRecordIdentity: false,
    singleActionFunctionName: "upsert",
    modelApiIdentifier,
    modelSelectionField: pluralModelApiIdentifier,
    namespace: null,
    variables: {
      inputs: { required: true, type: "[BulkUpsertAgentMessagesInput!]" }
    },
    paramOnlyVariables: ["on"],
    defaultSelection: DefaultAgentMessageSelection
  },
  {
    type: "computedView",
    operationName: "view",
    functionName: "view",
    gqlFieldName: "agentMessageGellyView",
    namespace: null,
    variables: {
      query: { type: "String", required: true },
      args: { type: "JSONObject" }
    }
  }
];
const AgentMessageManager = buildModelManager(
  modelApiIdentifier,
  pluralModelApiIdentifier,
  DefaultAgentMessageSelection,
  operations
);
export {
  AgentMessageManager,
  DefaultAgentMessageSelection
};
//# sourceMappingURL=AgentMessage.js.map
